<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="pro01">
<div class="chapterHead">
<h2 class="chapterTitle1"><span class="xrefInternal"><a href="#/contents#pro_01"><span class="smallCaps">PROLOGUE</span></a></span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText"><span class="chapterOpenerFirstLetters"><span class="bold"><em class="italic">A</em></span></span>t dawn, before the town of Aversa awoke from its slumbers, a sugar-pink woman with white hair was observed by the gargoyles sneaking toward the portal of the convent of Santa Maria della Pieta. She was holding by the hand a tiny replica of herself, a girl aged about three, who was biting and wailing and dragging her little feet in the dust so that it rose around them in a cloud. The two disappeared into the vestibule and seconds later the woman reappeared alone, closing the heavy door firmly behind her, and hurrying away. She did not look back.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?719f378c